import { parse } from 'query-string'

function getQueryParams(queryString) {
	return parse(queryString)
}

export default getQueryParams
